import { useEffect, useRef, useState } from "react";
import { api } from "../api";

export default function Chat() {
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const logRef = useRef(null);

  useEffect(() => { api("/chat").then((d) => setMessages(d.messages || [])).catch((e) => setErr(e.message)); }, []);
  useEffect(() => { if (logRef.current) logRef.current.scrollTop = logRef.current.scrollHeight; }, [messages, busy]);

  async function send(e) {
    e.preventDefault();
    const t = text.trim();
    if (!t || busy) return;
    setText(""); setErr("");
    setMessages((m) => [...m, { _id: "tmp-" + Date.now(), role: "user", text: t }]);
    setBusy(true);
    try { const { reply } = await api("/chat", { method: "POST", body: { text: t } }); setMessages((m) => [...m, reply]); }
    catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  }

  return (
    <div>
      <div className="page-head">
        <div><h1>Manager</h1><div className="sub">Posez une question sur l'état du capital, un pari, une décision — ou donnez une consigne.</div></div>
      </div>
      <div className="chat-wrap">
        <div className="chat-log" ref={logRef}>
          {messages.length === 0 && (
            <div className="bubble manager">Bonjour. Je supervise les agents et la politique de paris. Exemples : « pourquoi ce pari a-t-il été refusé ? », « où en est le capital ? », « baisse la fraction de Kelly ».</div>
          )}
          {messages.map((m, i) => <div key={m._id || i} className={"bubble " + (m.role === "user" ? "user" : "manager")}>{m.text}</div>)}
          {busy && <div className="bubble manager muted">Le Manager réfléchit…</div>}
        </div>
        {err && <p className="error" style={{ marginTop: 8 }}>{err}</p>}
        <form className="chat-input" onSubmit={send}>
          <input className="input" placeholder="Écrire au Manager…" value={text} onChange={(e) => setText(e.target.value)} />
          <button className="btn btn-primary" type="submit" disabled={busy || !text.trim()}>Envoyer</button>
        </form>
      </div>
    </div>
  );
}
